import { createApp } from "vue";
import main from "@/main.vue";
import store from "@plugins/store";
import { getBrowserTabUuid } from "@/utils/app.storage";
import "@utils/index.ts";
import "@css/main.css";

/* System store */
import appModule from "@modules/app/module";
import authModule from "@modules/auth/module";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";
import userActivityTrackEvent from "@plugins/user-activity-track/service/user.activity.track.event.ts";
//import appConfigs from "@configs/app";
//import VueGtag from "vue-gtag";

// Subscribed before app mount to catch CSP violations from the earliest script/style loads
window.addEventListener("securitypolicyviolation", (event: SecurityPolicyViolationEvent) => {
  userActivityTrackEvent.cspViolation({
    effectiveDirective: event.effectiveDirective,
    blockedUri: event.blockedURI,
    sourceFile: event.sourceFile,
  });
});

/* Initialize App Module */
store.registerModule(appModule.name, appModule.store);
store.registerModule(authModule.name, authModule.store);

//https://stackoverflow.com/questions/66954284/access-vue-3-app-instance-api-from-non-vue-fiile
//https://laracasts.com/discuss/channels/vue/get-app-instance-in-another-file
const AppMain = createApp(main);
AppInstanceUtils.installCommonPlugin(AppMain);
getBrowserTabUuid();
AppMain.mount("#app");
